// import './service-worker-registration'; - przeniesione do nagłowka

import './layout/mmenu-light';
import './layout/header-search';
import './layout/theme-layout-preferences';
import './layout/theme-schema-switcher';


// ---------------
// Ładowanie bloków
// ---------------
//Bloki statyczne - zawsze dostępne
import './blocks/silesia-core-tabs';
import './blocks/comments';
import './blocks/comments-form';

//Ładowane dynamicznie
// if(document.querySelector('*[x-data-lazy*="window.silesia.layout.tinySlider"]')) {
//     import(/* webpackChunkName: "block-tiny-slider" */ './blocks/tiny-slider');
// }
import './blocks/tiny-slider';

// if(document.querySelector('*[x-data-lazy*="window.silesia.layout.marque"]')) {
//     import(/* webpackChunkName: "block-marque" */ './blocks/marque');
// }
import './blocks/marque';

if(document.querySelector('*[x-data-lazy*="window.silesia.layout.categoryListGrid"]')) {
    import(/* webpackChunkName: "block-category-list-grid" */ './blocks/category-list-grid');
}

if(document.querySelector('*[x-data-lazy*="window.silesia.layout.ttsPlayer"]')) {
    import(/* webpackChunkName: "block-tts-player" */ './blocks/tts-player');
}

if(document.querySelector('*[x-data-lazy*="window.silesia.layout.meilisearch"]')) {
    import(/* webpackChunkName: "block-meilisearch" */ './blocks/meilisearch');
}

if(document.querySelector('*[x-data-lazy*="window.silesia.layout.eventCalendar"]')) {
    import(/* webpackChunkName: "block-event-calendar" */ './blocks/event-calendar');
}
// import('./blocks/event-calendar')


import './icons';

// ---------------
// Biblioteki ładowane na końcu, tak by wszystkie zmienne globalne dla komponentów zdążyły się zainicjować
// ---------------
import './vendor/alpine';
import './vendor/fslightbox';